import React from 'react';
import NewsArticleItem from '../../news-article-item/js/NewsArticleItem';

export default class NewsSearchItem extends React.PureComponent {

    render() {
        return (
            <div
                className={`listing__item listing__item--grid grid__item grid__item--span-tablet-6 grid__item--span-desktop-4`}>
                <NewsArticleItem {...this.props}/>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./app/components/news-search/js/NewsSearchItem.js